module.exports = __webpack_public_path__ + "static/img/materialsInfo20.d68683f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo20.png
// module id = cYI3
// module chunks = 2